/**
 *  @class
 *  @function B4UShopTheLook
 *
 *  Wrapper element that hooks into the inner <slide-show>'s Flickity instance
 *  to update the arrows-with-numbers counter and handle Shopify editor events.
 *  Flickity init itself is delegated to the existing <slide-show> custom element.
 */
if (!customElements.get('b4u-shop-the-look')) {
  class B4UShopTheLook extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Two rAFs: first lets browser paint, second lets slide-show's own rAF fire.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.init());
      });
    }

    init() {
      const slideShowEl = this.querySelector('.b4u-stl__slider');
      if (!slideShowEl) return;

      const flkty = Flickity.data(slideShowEl);
      if (!flkty) {
        // slide-show hasn't initialised yet — retry shortly.
        setTimeout(() => this.init(), 50);
        return;
      }

      this._flkty = flkty;

      const counter = this.querySelector('.flickity-custom-navigation--current');

      flkty.on('change', (index) => {
        if (counter) counter.innerHTML = index + 1;
      });

      // Shopify theme editor: select a block → jump to that slide.
      if (Shopify.designMode) {
        const slides = Array.from(this.querySelectorAll('.b4u-stl__slide'));
        this.addEventListener('shopify:block:select', (event) => {
          const index = slides.indexOf(event.target);
          if (index > -1) flkty.select(index);
        });
      }
    }

    disconnectedCallback() {
      // Flickity lifecycle is owned by <slide-show>; nothing extra to clean up here.
      this._flkty = null;
    }
  }

  customElements.define('b4u-shop-the-look', B4UShopTheLook);
}
